export default __webpack_public_path__ + "static/media/brrrrr.7e0ead77.jpg";